"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _rsuite = require("rsuite");

function InteractionModal(_ref) {
  var _ref$okButtonText = _ref.okButtonText,
      okButtonText = _ref$okButtonText === void 0 ? '确定' : _ref$okButtonText,
      onOk = _ref.onOk,
      _ref$showCancelButton = _ref.showCancelButton,
      showCancelButton = _ref$showCancelButton === void 0 ? true : _ref$showCancelButton,
      _ref$cancelButtonText = _ref.cancelButtonText,
      cancelButtonText = _ref$cancelButtonText === void 0 ? '取消' : _ref$cancelButtonText,
      onCancel = _ref.onCancel,
      children = _ref.children,
      _ref$canCancelOnLoadi = _ref.canCancelOnLoading,
      canCancelOnLoading = _ref$canCancelOnLoadi === void 0 ? false : _ref$canCancelOnLoadi;

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      shouldShowModal = _useState2[0],
      setShouldShowModal = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      submitLoading = _useState4[0],
      setSubmitLoading = _useState4[1];

  var handleReturnValueOfOnOk = (0, _react.useCallback)(function (returnValueOfOnOk) {
    if (!returnValueOfOnOk || !returnValueOfOnOk.then) {
      setShouldShowModal(false);
      return;
    }

    setSubmitLoading(true);
    returnValueOfOnOk.finally(function () {
      setSubmitLoading(false);
      setShouldShowModal(false);
    });
  }, []);
  var handleOk = (0, _react.useCallback)(function () {
    var returnValueOfOnOk = onOk && onOk();
    handleReturnValueOfOnOk(returnValueOfOnOk);
  }, [onOk, handleReturnValueOfOnOk]);
  var handleCancel = (0, _react.useCallback)(function () {
    setShouldShowModal(false); // pass current loading status to onCancel to distinguish different case

    onCancel && onCancel(submitLoading);
  }, [onCancel, submitLoading]); // eslint-disable-next-line consistent-return

  (0, _react.useEffect)(function () {
    function handleKeyDown(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        handleOk();
      }

      if (e.key === 'Escape') {
        e.preventDefault();

        if (showCancelButton) {
          handleCancel();
        } else {
          handleOk();
        }
      }
    }

    if (shouldShowModal) {
      document.addEventListener('keydown', handleKeyDown, false);
      return function () {
        document.removeEventListener('keydown', handleKeyDown, false);
      };
    }
  }, [shouldShowModal, handleOk, handleCancel, showCancelButton]);
  /**
   * using open/show judge by rsuite version
   * @example @3 propTypes undefined
   * @example @4 no 'open' in propTypes
   * @example @4 'open' in propTypes
   */

  var modalProps = (0, _defineProperty2.default)({}, _rsuite.Modal.propTypes && 'open' in _rsuite.Modal.propTypes ? 'open' : 'show', shouldShowModal);
  return _react.default.createElement(_rsuite.Modal, (0, _extends2.default)({
    role: "alertdialog",
    size: "xs",
    "aria-describedby": "alertdialog-description"
  }, modalProps), _react.default.createElement(_rsuite.Modal.Body, {
    id: "alertdialog-description"
  }, children), _react.default.createElement(_rsuite.Modal.Footer, null, showCancelButton && _react.default.createElement(_rsuite.Button, {
    disabled: submitLoading && !canCancelOnLoading,
    onClick: handleCancel
  }, cancelButtonText), _react.default.createElement(_rsuite.Button, {
    loading: submitLoading,
    onClick: handleOk,
    appearance: "primary"
  }, okButtonText)));
}

var _default = InteractionModal;
exports.default = _default;